// extracted by mini-css-extract-plugin
module.exports = {"noUnderline":"CommBannerLinkWrapper_noUnderline__ggH6r","link":"CommBannerLinkWrapper_link__YWdX2"};